import { getImgBaseUrl } from './getImgBaseUrl';
import { stringifyImageParams } from './stringifyImageParams';

const SHARING_SIZE = { width: 300, height: 300 };

export const getProductImageUrl = (productId: string, viewId: string) =>
  `${getImgBaseUrl()}/products/${productId}/views/${viewId}${stringifyImageParams(
    SHARING_SIZE
  )}.png`;
